import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, KeepAlive as _KeepAlive, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "app-shell" };
const _hoisted_2 = { class: "brand" };
const _hoisted_3 = { class: "brand-text" };
const _hoisted_4 = { class: "wx-card" };
const _hoisted_5 = ["title"];
const _hoisted_6 = { class: "content" };
import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';
import { Promotion, Connection, QuestionFilled, Fold, Expand } from '@element-plus/icons-vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'NavComponent',
    setup(__props) {
        const route = useRoute();
        const collapsed = ref(false);
        // 由当前路由驱动高亮，避免手动维护 index 与路由不同步
        const activeIndex = computed(() => route.path);
        return (_ctx, _cache) => {
            const _component_el_icon = _resolveComponent("el-icon");
            const _component_el_menu_item = _resolveComponent("el-menu-item");
            const _component_el_menu = _resolveComponent("el-menu");
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("aside", {
                    class: _normalizeClass(["sidebar", { collapsed: collapsed.value }])
                }, [
                    _createElementVNode("div", _hoisted_2, [
                        _cache[1] || (_cache[1] = _createElementVNode("img", {
                            src: "/Modbus-online.svg",
                            alt: "",
                            class: "brand-logo"
                        }, null, -1)),
                        _withDirectives(_createElementVNode("span", _hoisted_3, "Modbus 在线调试", 512), [
                            [_vShow, !collapsed.value]
                        ])
                    ]),
                    _createVNode(_component_el_menu, {
                        "default-active": activeIndex.value,
                        collapse: collapsed.value,
                        "collapse-transition": false,
                        "background-color": "#545c64",
                        "text-color": "#fff",
                        "active-text-color": "#ffd04b",
                        router: "",
                        class: "side-menu"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_el_menu_item, { index: "/rtu" }, {
                                title: _withCtx(() => _cache[2] || (_cache[2] = [
                                    _createTextVNode("Modbus RTU 调试", -1)
                                ])),
                                default: _withCtx(() => [
                                    _createVNode(_component_el_icon, null, {
                                        default: _withCtx(() => [
                                            _createVNode(_unref(Connection))
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_el_menu_item, { index: "/tcp" }, {
                                title: _withCtx(() => _cache[3] || (_cache[3] = [
                                    _createTextVNode("Modbus TCP 调试", -1)
                                ])),
                                default: _withCtx(() => [
                                    _createVNode(_component_el_icon, null, {
                                        default: _withCtx(() => [
                                            _createVNode(_unref(Promotion))
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_el_menu_item, { index: "/help" }, {
                                title: _withCtx(() => _cache[4] || (_cache[4] = [
                                    _createTextVNode("使用帮助", -1)
                                ])),
                                default: _withCtx(() => [
                                    _createVNode(_component_el_icon, null, {
                                        default: _withCtx(() => [
                                            _createVNode(_unref(QuestionFilled))
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }, 8, ["default-active", "collapse"]),
                    _withDirectives(_createElementVNode("div", _hoisted_4, _cache[5] || (_cache[5] = [
                        _createStaticVNode("<span class=\"wx-label\" data-v-7be32e9b><i class=\"wx-dot\" aria-hidden=\"true\" data-v-7be32e9b></i>扫码关注</span><div class=\"wx-qr-frame\" data-v-7be32e9b><img src=\"/wechat-qr.jpg\" alt=\"公众号：科苑沐泽 二维码\" class=\"wx-qr\" data-v-7be32e9b></div><p class=\"wx-name\" data-v-7be32e9b>公众号：<span class=\"wx-accent\" data-v-7be32e9b>科苑沐泽</span></p>", 3)
                    ]), 512), [
                        [_vShow, !collapsed.value]
                    ]),
                    _createElementVNode("button", {
                        class: "collapse-btn",
                        title: collapsed.value ? '展开侧栏' : '收起侧栏',
                        onClick: _cache[0] || (_cache[0] = ($event) => (collapsed.value = !collapsed.value))
                    }, [
                        _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                                (_openBlock(), _createBlock(_resolveDynamicComponent(collapsed.value ? _unref(Expand) : _unref(Fold))))
                            ]),
                            _: 1
                        })
                    ], 8, _hoisted_5)
                ], 2),
                _createElementVNode("main", _hoisted_6, [
                    _createVNode(_component_router_view, null, {
                        default: _withCtx(({ Component }) => [
                            (_openBlock(), _createBlock(_KeepAlive, null, [
                                (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                            ], 1024))
                        ]),
                        _: 1
                    })
                ])
            ]));
        };
    }
});
